import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  setDoc,
  deleteDoc,
  query,
  orderBy
} from "firebase/firestore";
import { db } from "./firebaseConfig";
import "./index.css";

function Programa() {
  const [dados, setDados] = useState([]);
  const [erro, setErro] = useState("");
  const [selecionado, setSelecionado] = useState(null);
  const [pesquisa, setPesquisa] = useState("");
  const [novo, setNovo] = useState({
    id: "",
    dia: "", semana: "", hora_inicio: "", hora_fim: "",
    sala: "", sessao: "", codigo_de_trabalho: "", outros: "",
    moderador1: "", moderador2: "", moderador3: "", moderador4: "",
    orador1: "", orador2: "", orador3: "", orador4: "", orador5: "",
    powered_by: "",
    pausa: false,
    ordem: 0
  });

  const fetchDados = async () => {
    try {
      const q = query(collection(db, "evento_programa"), orderBy("sessao", "asc"));
      const snapshot = await getDocs(q);
      setDados(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setErro("");
    } catch {
      setErro("Erro ao sincronizar os dados do programa.");
    }
  };

  useEffect(() => { fetchDados(); }, []);

  const deletarPrograma = async (id) => {
    if (!window.confirm("Tem certeza de que deseja excluir este programa da app?")) return;
    try {
      await deleteDoc(doc(db, "evento_programa", id));
      setDados(prev => prev.filter(d => d.id !== id));
    } catch {
      window.alert("Erro ao apagar o programa.");
    }
  };

  const salvarTudo = async () => {
    if (!selecionado) return;
    let id = selecionado.id;

    try {
      if (id.startsWith("temp-")) {
        const docRef = doc(collection(db, "evento_programa"));
        await setDoc(docRef, novo);
        id = docRef.id;
        setDados(prev => prev.map(d => d.id === selecionado.id ? { ...novo, id } : d));
      } else {
        await updateDoc(doc(db, "evento_programa", id), novo);
        setDados(prev => prev.map(d => d.id === id ? { ...novo, id } : d));
      }

      setSelecionado(null);
      window.alert("Alterações guardadas.");
    } catch {
      window.alert("Erro ao guardar as alterações.");
    }
  };

  const exportarCSV = () => {
    const headers = [
      "id", "ordem", "dia", "semana", "hora_inicio", "hora_fim",
      "sala", "sessao", "codigo_de_trabalho", "outros",
      "moderador1", "moderador2", "moderador3", "moderador4",
      "orador1", "orador2", "orador3", "orador4", "orador5",
      "powered_by",
      "pausa"
    ];

    const rows = dados.length
      ? dados.map(d => headers.map(h => d[h] ?? ""))
      : [headers.map(() => "")];

    const csv = [headers, ...rows].map(r => r.map(v => `"${v}"`).join(",")).join("\n");
    const bom = "\uFEFF";
    const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "programa.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // *******************************************************************
  //  IMPORTAÇÃO CSV com deteção automática (TAB, ; ou ,)
  // *******************************************************************
  const handleImportarCSV = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    window.alert("A sua importação está em processamento. Por favor, aguarde...");

    try {
      const text = await file.text();
      const lines = text.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
      if (lines.length < 2) throw new Error("ficheiro vazio");

      // DETEÇÃO AUTOMÁTICA DO SEPARADOR
      const firstLine = lines[0];
      const sep =
        firstLine.includes("\t") ? "\t" :
        firstLine.includes(";")  ? ";"  :
        ",";

      const clean = s => s.replace(/^\uFEFF/, "").replace(/"/g, "").trim();
      const headers = firstLine.split(sep).map(clean);

      if (!headers.includes("sessao") || !headers.includes("codigo_de_trabalho"))
        throw new Error("estrutura inválida");

      const existentes = new Map(dados.map(d => [`${d.sessao}|${d.codigo_de_trabalho}`, d]));

      let adicionados = 0, atualizados = 0;

      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(sep).map(clean);
        const obj = {};

        headers.forEach((h, j) => {
          obj[h] = values[j] ?? "";
        });

        obj.pausa = obj.pausa === "true";
        obj.ordem = obj.ordem ? parseInt(obj.ordem) : 0;

        // PRIORIDADE 1 → se tiver ID, usa esse ID
        if (obj.id) {
          const docRef = doc(db, "evento_programa", obj.id);
          const snap = await getDoc(docRef);

          if (snap.exists()) {
            await updateDoc(docRef, obj);
            atualizados++;
          } else {
            await setDoc(docRef, obj);
            adicionados++;
          }
        } else {
          // PRIORIDADE 2 → usar sessao + codigo_de_trabalho
          const key = `${obj.sessao}|${obj.codigo_de_trabalho}`;

          if (existentes.has(key)) {
            const idExistente = existentes.get(key).id;
            await updateDoc(doc(db, "evento_programa", idExistente), obj);
            atualizados++;
          } else {
            await setDoc(doc(collection(db, "evento_programa")), obj);
            adicionados++;
          }
        }
      }

      await fetchDados();
      window.alert(`Importação concluída. Inseridos: ${adicionados}, Atualizados: ${atualizados}.`);

    } catch (err) {
      console.error(err);
      window.alert("A sua importação falhou. Estrutura do CSV inválida.");
    }

    e.target.value = null;
  };

  const dadosFiltrados = dados.filter(
    item =>
      item.sessao?.toLowerCase().includes(pesquisa.toLowerCase()) ||
      item.codigo_de_trabalho?.toLowerCase().includes(pesquisa.toLowerCase())
  );

  const listaModeradores = d =>
    [d.moderador1, d.moderador2, d.moderador3, d.moderador4].filter(Boolean).join(", ");

  const listaOradores = d =>
    [d.orador1, d.orador2, d.orador3, d.orador4, d.orador5].filter(Boolean).join(", ");

  if (erro) return <p>{erro}</p>;

  return (
    <div className="table-container">
      <div>
        <input
          type="text"
          placeholder="Procurar por trabalho"
          value={pesquisa}
          onChange={e => setPesquisa(e.target.value)}
          className="input"
        />
        <button className="btn btn-other" onClick={exportarCSV}>Exportar CSV</button>
        <label className="btn btn-other">
          Importar CSV
          <input type="file" accept=".csv" style={{ display: "none" }} onChange={handleImportarCSV} />
        </label>
      </div>

      {dadosFiltrados.length === 0 ? (
        <p style={{ textAlign: "center", color: "#292f2c" }}>Sem dados</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Ordem</th>
              <th>Sessão</th>
              <th>Código Trabalho</th>
              <th>Dia</th>
              <th>Hora</th>
              <th>Sala</th>
              <th>Moderadores</th>
              <th>Oradores</th>
              <th>Outros</th>
              <th>Powered By</th>
              <th>Pausa</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {dadosFiltrados.map(item => (
              <tr key={item.id}>
                <td
                  style={{ cursor: "pointer" }}
                  title="Clique para copiar o ID"
                  onClick={() => navigator.clipboard.writeText(item.id)}
                >
                  {item.id}
                </td>
                <td>{item.ordem || 0}</td>
                <td>{item.sessao || "—"}</td>
                <td>{item.codigo_de_trabalho || "—"}</td>
                <td>{item.dia || "—"}</td>
                <td>{item.hora_inicio && item.hora_fim ? `${item.hora_inicio} - ${item.hora_fim}` : "—"}</td>
                <td>{item.sala || "—"}</td>
                <td>{listaModeradores(item) || "—"}</td>
                <td>{listaOradores(item) || "—"}</td>
                <td>{item.outros || "—"}</td>
                <td>{item.powered_by || "—"}</td>
                <td>{item.pausa ? "Sim" : "Não"}</td>
                <td>
                  <button
                    className="btn btn-add"
                    onClick={() => {
                      setSelecionado(item);
                      setNovo(item);
                    }}
                  >
                    Editar
                  </button>
                  <button className="btn btn-delete" onClick={() => deletarPrograma(item.id)}>
                    Apagar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {selecionado && (
        <div className="drawer">
          <div className="drawer-content">

            <div style={{ marginBottom: "10px" }}>
              <label>Data:</label>
              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  value={novo.dia}
                  placeholder="Dia"
                  onChange={e => setNovo(p => ({ ...p, dia: e.target.value }))}
                  style={{ flex: 1 }}
                />
                <input
                  type="text"
                  value={novo.semana}
                  placeholder="Semana"
                  onChange={e => setNovo(p => ({ ...p, semana: e.target.value }))}
                  style={{ flex: 1 }}
                />
              </div>
            </div>

            <div style={{ marginBottom: "10px" }}>
              <label>Horário:</label>
              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  style={{ flex: 1 }}
                  value={novo.hora_inicio}
                  placeholder="Início"
                  onChange={e => setNovo(p => ({ ...p, hora_inicio: e.target.value }))}
                />
                <input
                  type="text"
                  style={{ flex: 1 }}
                  value={novo.hora_fim}
                  placeholder="Fim"
                  onChange={e => setNovo(p => ({ ...p, hora_fim: e.target.value }))}
                />
              </div>
            </div>

            {["id", "ordem", "sala", "sessao", "codigo_de_trabalho", "outros", "powered_by"].map(campo => (
              <div key={campo} style={{ marginBottom: "8px" }}>
                <label>{campo}:</label>
                <input
                  type={campo === "ordem" ? "number" : "text"}
                  value={novo[campo]}
                  onChange={e => setNovo(p => ({ ...p, [campo]: campo === "ordem" ? parseInt(e.target.value) : e.target.value }))}
                />
              </div>
            ))}

            <div style={{ marginBottom: "8px" }}>
              <label>Pausa:</label>
              <input
                type="checkbox"
                checked={novo.pausa}
                onChange={e => setNovo(p => ({ ...p, pausa: e.target.checked }))}
              />
            </div>

            <div style={{ marginBottom: "8px" }}>
              <label>Moderadores:</label>
              {["moderador1", "moderador2", "moderador3", "moderador4"].map(m => (
                <input
                  type="text"
                  key={m}
                  value={novo[m]}
                  onChange={e => setNovo(p => ({ ...p, [m]: e.target.value }))}
                />
              ))}
            </div>

            <div style={{ marginBottom: "8px" }}>
              <label>Oradores:</label>
              {["orador1", "orador2", "orador3", "orador4", "orador5"].map(o => (
                <input
                  type="text"
                  key={o}
                  value={novo[o]}
                  onChange={e => setNovo(p => ({ ...p, [o]: e.target.value }))}
                />
              ))}
            </div>

          </div>

          <div className="drawer-footer">
            <button className="btn btn-add" onClick={salvarTudo}>Guardar</button>
            <button className="btn btn-cancel" onClick={() => setSelecionado(null)}>Cancelar</button>
          </div>

        </div>
      )}
    </div>
  );
}

export default Programa;
